export default {
	primary: {
		main: '#3980bf',
	},
	primarySubDark: '#194f80',
	primarySubLight: '#3978b0',
	primaryGradient1: '#135086',
	primaryGradient2: '#0e4372',
}
